import Table from "./base"
import { getDynamicData, getTotalData } from "./methods"

export { getDynamicData, getTotalData }

export default Table
